var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPowerButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.368 45.999H10",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.684 49.6836C23.9747 49.6836 24.2103 49.9192 24.2103 50.2099V50.2099C24.2103 50.5006 23.9747 50.7362 23.684 50.7362V50.7362C23.3934 50.7362 23.1577 50.5006 23.1577 50.2099V50.2099C23.1577 49.9192 23.3934 49.6836 23.684 49.6836",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.368 35.4732V50.2098C37.368 52.5352 35.4829 54.4202 33.1575 54.4202H14.2105C11.8851 54.4202 10 52.5352 10 50.2098V10.2105C10 7.88508 11.8851 6 14.2105 6H26.8418",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7888 10.2109C49.4134 12.9294 50.8918 17.6622 49.4591 21.9605C48.0263 26.2588 44.0039 29.158 39.4731 29.158C34.9423 29.158 30.9199 26.2588 29.4871 21.9605C28.0544 17.6622 29.5328 12.9294 33.1574 10.2109",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4731 6V16.5261",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPowerButton);
export default __webpack_public_path__ + "static/media/icon-power-button.f75389c8.svg";
export { ForwardRef as ReactComponent };